import { useNavigate } from 'react-router-dom';
import '../css/TemplatesPage.css';
import TemplateCard from '../components/template/TemplateCard';


const TEMPLATES = [
  {
    id: 'demo-1',
    name: 'Shoppable Spotlight',
    tag: 'Best for eCommerce',
    layout: 'layout1',
    accent: 'from-indigo-500 to-sky-400',
    videoURL: "https://test-pages.b-cdn.net/SocialTV/Master/layout1.mp4",
    canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
    currentTime: 2,
    status: true
  },
  {
    id: 'demo-2',
    name: 'Brand Showcase',
    tag: 'Best for eCommerce',
    layout: 'layout2',
    accent: 'from-indigo-500 to-sky-400',
    videoURL: "https://test-pages.b-cdn.net/SocialTV/Master/layout2.mp4",
    canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
    currentTime: 2,
    status: true
  },
  {
    id: 'demo-3',
    name: 'Mobile Experience',
    tag: 'Best for eCommerce',
    layout: 'layout3',
    accent: 'from-indigo-500 to-sky-400',
    videoURL: "https://test-pages.b-cdn.net/SocialTV/Master/layout3.mp4",
    canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
    currentTime: 2,
    status: true
  },
  // {
  //   id: 'demo-4',
  //   name: 'Scan & Engage',
  //   tag: 'Best for eCommerce',
  //   layout: 'layout2',
  //   accent: 'from-indigo-500 to-sky-400',
  //   videoURL: "https://test-pages.b-cdn.net/h&m/hm-summer-collection-1/6f13dda0-1ffe-49bf-8e8f-5003abac46b1.mp4",
  //   canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
  //   currentTime: 2
  // },
  {
    id: 'demo-5',
    name: 'Product Collection (L-shape)',
    tag: 'Best for eCommerce',
    layout: 'layout4',
    accent: 'from-indigo-500 to-sky-400',
    videoURL: "https://test-pages.b-cdn.net/SocialTV/Master/layout4A.mp4",
    canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
    currentTime: 5,
    status: true
  },
  // {
  //   id: 'demo-6',
  //   name: 'Smart Shopping (L-shape)',
  //   tag: 'Best for eCommerce',
  //   layout: 'layout4B',
  //   accent: 'from-indigo-500 to-sky-400',
  //   videoURL: "https://test-pages.b-cdn.net/SocialTV/layout4_output_right.mp4",
  //   canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
  //   currentTime: 5,
  //   status: false
  // },
  {
    id: 'demo-7',
    name: 'Sale Timer (L-shape)',
    tag: 'Best for Sale',
    layout: 'layout4C',
    accent: 'from-indigo-500 to-sky-400',
    videoURL: "https://test-pages.b-cdn.net/SocialTV/Master/layout4C.mp4",
    canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
    currentTime: 5,
    status: true
  },
  {
    id: 'demo-8',
    name: 'Product Showcase',
    tag: 'Best for Sale',
    layout: 'layout6',
    accent: 'from-indigo-500 to-sky-400',
    videoURL: "https://test-pages.b-cdn.net/SocialTV/Master/layout6.mp4",
    canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
    currentTime: 5,
    status: true
  },
  {
    id: 'demo-9',
    name: 'Product Slider',
    tag: 'Best for Sale',
    layout: 'layout7',
    accent: 'from-indigo-500 to-sky-400',
    videoURL: "https://test-pages.b-cdn.net/SocialTV/Master/layout7.mp4",
    canvas: { gradientColor1: '#eef2ff', gradientColor2: '#dbeafe', gradientAngle: 135 },
    currentTime: 5,
    status: true
  },
];

export default function TemplatesPage() {
  const navigate = useNavigate();

  const handleUseTemplate = (t) => {
    navigate('/dashboard/editor', { state: { templateId: t.id, layout: t.layout } });
  };

  return (
    <div className="templates-page">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-slate-900">Templates</h1>
          <p className="text-sm text-slate-500">
            Pick a starting point — beautiful CTV-ready layouts you can customize in the editor.
          </p>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">
        {TEMPLATES.filter(a => a.status).map((t) => (
          <TemplateCard
            key={t.id}
            t={t}
            handleUseTemplate={handleUseTemplate}
          />
        ))}
      </div>

    </div>
  );
}

